import styled, { css } from 'styled-components';
import boardSrc from 'assets/images/board.min.png';

export const SWrapper = styled.div<{ isPlaying: boolean }>`
  max-height: 660px;
  position: relative;
  padding: 55px 20px 60px;
  user-select: none;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-image: url('${boardSrc}');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
  }

  @media (max-width: 840px) and (max-aspect-ratio: 1/1) {
    padding: 50px 20px 40px;

    &:after {
      display: none;
    }
  }

  @media (max-width: 600px) and (max-aspect-ratio: 1/1) {
    padding: 42px 20px 38px;
  }

  @media (max-width: 520px) and (max-aspect-ratio: 1/1) {
    padding: 36px 15px 34px;
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    padding: 30px 10px 30px;
  }

  @media (max-width: 400px) and (max-aspect-ratio: 1/1) {
    padding: 26px 10px 25px;
  }

  @media (max-width: 320px) and (max-aspect-ratio: 1/1) {
    padding: 22px 10px 20px;
  }
`;

export const SInner = styled.div<{
  disabled: boolean;
  cellAnimDelay: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}

  ${({ cellAnimDelay }) => cellAnimDelay}
`;
